import React from 'react'
import { AutoCompleteField, DateField, TextField } from '~/components/fields'
import { OptionalLabel } from './optional-label'
import styled from 'styled-components'
import { countriesSelectOptionStore } from '~/stores'

const WorkContainer = styled.div`
	margin-bottom: 24px;
	background-color: #ffffff;
	border-radius: 8px;
	border: 1px solid #e6e6e6;
	padding: 16px 16px 24px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`

const StyledFieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	.MuiFormControl-root {
		width: 100%;
	}

	.MuiInputLabel-root {
		color: #263349;
		font-family: Inter;
		font-weight: 600;
		font-size: 14px;
		line-height: 1.7142857142857142em;
		margin-bottom: 4px;
	}

	.MuiInputBase-root {
		border: none;
		border-bottom: 1px solid #d1d1d1;
		border-radius: 0;
		padding: 0px 0px 8px;

		&:before {
			display: none;
		}

		&:after {
			display: none;
		}

		&:hover {
			border-bottom: 1px solid #d1d1d1;

			&:before {
				display: none;
			}
		}

		&.Mui-focused {
			border-bottom: 1px solid #d1d1d1;

			&:after {
				display: none;
			}
		}
	}

	.MuiFormHelperText-root {
		display: none;
	}
`

const RemoveButton = styled.button`
	background: none;
	flex: 1;
	justify-content: center;
	display: flex;
	border: none;
	color: #ff2727;
	font-family: Inter;
	font-weight: 700;
	font-size: 14px;
	line-height: 1.7142857142857142em;
	cursor: pointer;
	padding: 8px 0px;
	text-align: left;
	width: 100%;
	margin-top: 0px;

	&:hover {
		opacity: 0.8;
	}
`

const WorkItem = ({ index, onDelete }) => {
	return (
		<WorkContainer>
			<StyledFieldWrapper>
				<TextField name={`workHistory.${index}.company`} label="COMPANY" placeholder="Enter company name" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<TextField name={`workHistory.${index}.position`} label="TITLE" placeholder="Enter position title" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<DateField name={`workHistory.${index}.startDate`} label="START_DATE" maxDate={new Date()} endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<DateField name={`workHistory.${index}.endDate`} label="END_DATE" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<TextField name={`workHistory.${index}.address1`} label="ADDRESS_1" placeholder="Enter address" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<TextField name={`workHistory.${index}.address2`} label="ADDRESS_2" placeholder="Enter address" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<TextField name={`workHistory.${index}.city`} label="CITY" placeholder="Enter city" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<TextField name={`workHistory.${index}.state`} label="STATE" placeholder="Enter state" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<AutoCompleteField
					name={`workHistory.${index}.country`}
					label="COUNTRY"
					placeholder="Select country"
					options={countriesSelectOptionStore.dataSource}
					endLabel={<OptionalLabel />}
				/>
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<TextField name={`workHistory.${index}.zipcode`} label="Zip" placeholder="Enter zip code" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<RemoveButton onClick={onDelete}>Remove</RemoveButton>
		</WorkContainer>
	)
}

export default WorkItem
